import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AmSliderPointsModule } from '@am/am-alliances-slider';

import { AmRewardsPricingModule } from '@am/rewards-pricing';
import { SharedModule } from '@shared/shared.module';
import { ResultsRoutingModule } from './results-routing.module';
import { ResultsComponent } from './results.component';

import { FormsModule } from '@angular/forms';
import { HotelsService } from '@core/services/hotels.service';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CheckPipe } from '@shared/pipes/check.pipe';
import * as fromResults from '@results/store';
import { ResultsEffecs } from '@results/store/results.effects';

@NgModule({
  declarations: [ResultsComponent],
  imports: [
    CommonModule,
    OverlayModule,
    ResultsRoutingModule,
    SharedModule,
    StoreModule.forFeature('results', fromResults.reducers),
    EffectsModule.forFeature([ResultsEffecs]),
    FormsModule,
    AmRewardsPricingModule,
    AmSliderPointsModule,
  ],
  providers: [HotelsService, CurrencyPipe, CheckPipe],
})
export class ResultsModule {}
